import { useLanguage } from '../context/LanguageContext';

/**
 * Breadcrumb Component
 * مكون المسارات - يعرض مسار التنقل الحالي
 * 
 * @param {string} pathAr - المسار بالعربية
 * @param {string} pathEn - المسار بالإنجليزية
 * @param {string} className - classes إضافية (اختياري)
 */
export default function Breadcrumb({ pathAr, pathEn, className = '' }) {
  const { language } = useLanguage();
  
  const path = language === 'ar' ? pathAr : pathEn;
  
  return (
    <div className={`mb-4 ${className}`}>
      <p className="text-xs text-[#606060]">{path}</p>
    </div>
  );
}

/**
 * Helper function to get breadcrumb paths
 * دالة مساعدة للحصول على مسارات الصفحات
 */
export const BREADCRUMB_PATHS = {
  // لوحة التحكم
  dashboard: {
    ar: 'لوحة التحكم',
    en: 'Dashboard'
  },
  dashboardControl: {
    ar: 'لوحة التحكم / التحكم والمعلومات',
    en: 'Dashboard / Control & Info'
  },
  dashboardPlatforms: {
    ar: 'لوحة التحكم / الإشراف على المنصات',
    en: 'Dashboard / Platform Supervision'
  },
  dashboardFinance: {
    ar: 'لوحة التحكم / المالية',
    en: 'Dashboard / Finance'
  },
  dashboardMarketing: {
    ar: 'لوحة التحكم / التسويق',
    en: 'Dashboard / Marketing'
  },
  dashboardSupport: {
    ar: 'لوحة التحكم / الدعم والمساعدة',
    en: 'Dashboard / Support'
  },
  dashboardManagement: {
    ar: 'لوحة التحكم / الإدارة',
    en: 'Dashboard / Management'
  },
  dashboardPerformance: {
    ar: 'لوحة التحكم / تحليل الأداء',
    en: 'Dashboard / Performance Analysis'
  },
  
  // التحكم والمعلومات
  controlCustomerPlatform: {
    ar: 'التحكم والمعلومات / منصة العملاء',
    en: 'Control & Info / Customer Platform'
  },
  controlMerchantPlatform: {
    ar: 'التحكم والمعلومات / منصة التجار',
    en: 'Control & Info / Merchant Platform'
  },
  
  // إعدادات الحساب
  accountSettings: {
    ar: 'إعدادات الحساب',
    en: 'Account Settings'
  },
  
  // الدعم
  support: {
    ar: 'الدعم والمساعدة',
    en: 'Support'
  },
  supportCenter: {
    ar: 'الدعم والمساعدة / مركز الدعم',
    en: 'Support / Support Center'
  },
  adminSupport: {
    ar: 'الدعم والمساعدة / دعم المشرفين',
    en: 'Support / Admin Support'
  },
  
  // التواصل
  contactRequests: {
    ar: 'طلبات التواصل',
    en: 'Contact Requests'
  },
  
  // المالية
  finance: {
    ar: 'المالية',
    en: 'Finance'
  },
  
  // التسويق
  marketing: {
    ar: 'التسويق',
    en: 'Marketing'
  },
  
  // خدمات الترجمة القانونية
  legalTranslation: {
    ar: 'التحكم والمعلومات / منصة العملاء / خدمات الترجمة القانونية',
    en: 'Control & Info / Customer Platform / Legal Translation Services'
  },
  
  // متطلبات التأشيرة
  visaRequirements: {
    ar: 'التحكم والمعلومات / منصة العملاء / متطلبات التأشيرة',
    en: 'Control & Info / Customer Platform / Visa Requirements'
  },
  
  // إدارة الفئات
  categoriesManagement: {
    ar: 'التحكم والمعلومات / إدارة الفئات',
    en: 'Control & Info / Categories Management'
  },
  
  // أنواع المتاجر
  storeTypesManagement: {
    ar: 'التحكم والمعلومات / منصة التجار / أنواع المتاجر',
    en: 'Control & Info / Merchant Platform / Store Types'
  },
};
